import script from "./ProfileAddParentsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileAddParentsModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileAddParentsModal.vue?vue&type=style&index=0&id=8fc00da0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fc00da0"]])

export default __exports__